import types from '../types'
import Action from '../../types/Action'

const initialState = {
    newsAndUpdates: {
        loading: true,
        error: false,
        success: false,
        data: []
    },
    announcement: {
        loading: true,
        error: false,
        success: false,
        data: []
    }
}

const newsUpdatesReducer = (state = initialState, action: Action) => {
    switch (action.type) {
        case types.GET_NEWS_UPDATES_REQUESTED: {
            return {
                ...state,
                newsAndUpdates: {
                    loading: true,
                    error: false,
                    success: false,
                    data: []
                }
            }
        }
        case types.GET_NEWS_UPDATES_FULFILLED: {
            return {
                ...state,
                newsAndUpdates: {
                    ...state.newsAndUpdates,
                    loading: false,
                    success: true,
                    data: action.payload
                }
            }
        }
        case types.GET_NEWS_UPDATES_REJECTED: {
            return {
                ...state,
                newsAndUpdates: {
                    ...state.newsAndUpdates,
                    loading: false,
                    error: action.payload
                }
            }
        }
        case types.GET_NEWS_UPDATES_BY_ORGANIZATION_REQUESTED: {
            return {
                ...state,
                newsAndUpdates: {
                    loading: true,
                    error: false,
                    success: false,
                    data: []
                }
            }
        }
        case types.GET_NEWS_UPDATES_BY_ORGANIZATION_FULFILLED: {
            return {
                ...state,
                newsAndUpdates: {
                    ...state.newsAndUpdates,
                    loading: false,
                    success: true,
                    data: action.payload
                }
            }
        }
        case types.GET_NEWS_UPDATES_BY_ORGANIZATION_REJECTED: {
            return {
                ...state,
                newsAndUpdates: {
                    ...state.newsAndUpdates,
                    loading: false,
                    error: action.payload
                }
            }
        }
        case types.GET_ANNOUNCEMENT_REQUESTED: {
            return {
                ...state,
                announcement: {
                    loading: true,
                    error: false,
                    success: false,
                    data: []
                }
            }
        }
        case types.GET_ANNOUNCEMENT_FULFILLED: {
            return {
                ...state,
                announcement: {
                    ...state.announcement,
                    loading: false,
                    success: true,
                    data: action.payload
                }
            }
        }
        case types.GET_ANNOUNCEMENT_REJECTED: {
            return {
                ...state,
                announcement: {
                    ...state.announcement,
                    loading: false,
                    error: action.payload
                }
            }
        }
        default:
            return state
    }
}

export default newsUpdatesReducer